$(function () {
	new Swiper('#firstBanner', {
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		loop: true,
		slidesPerView: 'auto',
		pagination: {
			el: '.benefit-s-pagination',
			clickable: true,
		},
	})
	var schoolBox = new Swiper('#schoolBox', {
		autoplay: {
			delay: 3000,
			disableOnInteraction: true,
		},
		loop: true,
		pagination: {
			el: '.swiper-pagination',
		},
	})
	var firstSwiper = new Swiper('#firstSwiper', {
		autoplay: {
			delay: 3000,
			disableOnInteraction: true,
		},
		loop: true,
		effect: 'coverflow',
		slidesPerView: 2,
		centeredSlides: true,
		coverflowEffect: {
			rotate: 0,
			stretch: 420,
			depth: 200,
		},
	})

	$('#knowDetail .know-btn').click(function (event) {
		$('.show-pic .dialogue')
			.eq($(this).parent().parent().index())
			.addClass('show-dialogue')
			.siblings()
			.removeClass('show-dialogue')
	})
	$('.show-pic .dialogue .hidden-icon').click(function (event) {
		$(this).parent().removeClass('show-dialogue')
	})

	// 雅思备考资料
	$('.form-one').listenForm({
		siteId: 55,
		contentName: '2020雅思专题上面领取资料',
		submitTarget: '#submitBtn1',
		isMsg: true,
		smsInfo: '【新航道】新航道《备考秘籍》下载提取码：pkus',
		successFun: function () {
			alertBg('.succeed', 'https://pan.baidu.com/s/17g24FBXEZkXGBLe3cADkjw')
		},
	})
	// 雅思备考资料
	$('.form-two').listenForm({
		siteId: 55,
		contentName: '2020雅思专题底部领取资料',
		submitTarget: '#submitBtn2',
		isMsg: true,
		smsInfo: '【新航道】新航道《备考秘籍》下载提取码：pkus',
		successFun: function () {
			alertBg('.succeed', 'https://pan.baidu.com/s/17g24FBXEZkXGBLe3cADkjw')
		},
	})
	// 底部漂浮预约
	$('.form-three').listenForm({
		siteId: 55,
		contentName: '2020雅思专题底部预约',
		submitTarget: '#submitBtn3',
		cityRequired: true,
		courseRequired: true,
	})

	function alertBg(alertBgName, baiduLink) {
		$('.succeed').css('display', 'block')
		//  网盘链接弹框 显示
		var _html = '<a href=' + baiduLink + '>' + baiduLink + '</a>'
		$('.succeed').find('.link').html(_html)
	}
	// 漂浮
	$('.guanbi').click(function () {
		$('.form-three').css('display', 'none')
	})
	// 获取城市
	$('.show-shadow .option').click(function () {
		$('.show-shadow .current').text($(this).text())
		$('.city01').val($(this).text())
	})
	$('.form-two .option').click(function () {
		$('.form-two .list-input').text($(this).text())
		$('.city02').val($(this).text())
	})
	// 获取课程
	$('.select-one .option').click(function () {
		$('.select-one .current').text($(this).text())
		$('.couse01').val($(this).text())
	})
	$('.choose-city .option').click(function () {
		$('.choose-city .current').text($(this).text())
		$('.city03').val($(this).text())
	})
	$('.alert-icon').click(function () {
		$('.succeed').css('display', 'none')
	})

	$('.pclose').click(function () {
		$('.piaofu').css('display', 'none')
	})
	function scrollTop(ele, dom) {
		$(ele).on('click', function () {
			var top1 = $(dom).offset().top
			$('html,body').animate({
				scrollTop: top1,
			})
		})
	}

	scrollTop('.pToTop', '.banner')
})
